import { useQuery } from '@tanstack/react-query';
import { Link, Stack, CardActionArea, Typography, Grid2 } from '@mui/material';
import { ImageWithFallback } from '@qb/frontend/components/ImageWithFallback';
import { spsClientQueries } from '@qb/httpRequest/spsClientQueries';
import { getSPSCategoryManufacturerURL, getSPSCategoryURL } from '@/global/utils/spsURLs';
import { SPSPartCategoryAllCategoriesResponse } from '@/shared/types/controllers/sps/SPSPartCategoryControllerTypes';
import { GetManufacturerSearchDataResponse } from '@/shared/types/controllers/sps/SPSSearchControllerTypes';
type CategoryCardProps = {
  category: SPSPartCategoryAllCategoriesResponse['allPartCategories'][0];
  tenantAlias: string;
  manufacturer?: GetManufacturerSearchDataResponse['manufacturer'];
};
export const CategoryCard = ({
  category,
  tenantAlias,
  manufacturer
}: CategoryCardProps) => {
  const {
    data: tenantConfig,
    isSuccess
  } = useQuery(spsClientQueries.app.tenantConfig(tenantAlias));
  if (!isSuccess) {
    return null;
  }
  return <Grid2 key={category.id} size={{
    xs: 6,
    sm: 6,
    md: 4,
    lg: 3
  }} data-sentry-element="Grid2" data-sentry-component="CategoryCard" data-sentry-source-file="CategoryCard.tsx">
      <Link href={manufacturer ? getSPSCategoryManufacturerURL({
      category,
      manufacturer
    }) : getSPSCategoryURL(category)} underline="none" data-sentry-element="Link" data-sentry-source-file="CategoryCard.tsx">
        <Stack component={CardActionArea} sx={{
        bgcolor: 'common.white',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        pt: 3,
        pb: 2
      }} data-sentry-element="Stack" data-sentry-source-file="CategoryCard.tsx">
          <ImageWithFallback tenantAlias={tenantAlias} src={category.imageURL} alt={`${category.name} on ${tenantConfig.companyName}`} width={100} height={100} data-sentry-element="ImageWithFallback" data-sentry-source-file="CategoryCard.tsx" />
          <Typography variant="bodyMediumPrimary" sx={{
          pt: 3,
          px: 1.5,
          textAlign: 'center',
          color: 'text.primary'
        }} data-sentry-element="Typography" data-sentry-source-file="CategoryCard.tsx">
            {category.name}
          </Typography>
        </Stack>
      </Link>
    </Grid2>;
};